/* eslint-disable no-nested-ternary */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { FaChevronUp } from '@react-icons/all-files/fa/FaChevronUp';
import { FaChevronDown } from '@react-icons/all-files/fa/FaChevronDown';
import { generatePlaceholderString } from 'gatsby-core-theme/src/helpers/generators.mjs';
import useTranslate from '~hooks/useTranslate/useTranslate';
import { getKeyValues, getInfoGridColumnValues } from '../../../../helpers/info-grid';
import { defaultInfoGrid, twoColInfoGrid } from '../../../../constants/info-grid';
import InfoGridItem from '../grid-item';
import InfoColumnItem from '../column-item';
import styles from './info-grid.module.scss';

const InfoGrid = ({
  page,
  showTwoColumns = false,
  showHyphen = false,
  infoIcon,
  detailsIcon,
  showEmojis = false,
  showSeeMoreButton = false,
  showInitial = 6,
  showTitle = true,
  templateThree = false,
  modulePosition
}) => {
  const ref = useRef();

  const { template, relation, market } = page;
  const [showMore, setShowMore] = useState(false);
  const gridLabels = showTwoColumns
    ? twoColInfoGrid[template] || Object.values(twoColInfoGrid)[0]
    : defaultInfoGrid[template] || Object.values(defaultInfoGrid)[0];
  const gridItems = showTwoColumns
    ? getInfoGridColumnValues(relation, gridLabels, market)
    : getKeyValues(relation, gridLabels, market);
  const templateTwo = showSeeMoreButton;

  const showGridItems = () => (
    <div
      ref={ref}
      className={`${templateTwo ? styles.singleColumn || '' : styles.grid || ''} ${
        templateThree ? styles.templateThree || '' : ''
      }`}
    >
      {Object.keys(gridItems)
        .slice(
          0,
          showSeeMoreButton
            ? showMore
              ? Object.values(gridItems).length
              : showInitial
            : Object.values(gridItems).length
        )
        .map((key) => (
          <InfoGridItem
            key={key}
            templateTwo={templateTwo}
            showEmojis={showEmojis}
            showHyphen={showHyphen}
            gridKey={key}
            gridLabels={gridLabels}
            gridItems={gridItems}
            template={template}
            templateThree={templateThree}
            modulePosition={modulePosition}
          />
        ))}
    </div>
  );

  return (
    <div className={styles.container || ''}>
      {showTwoColumns ? (
        <div className={styles.containerColumn || ''}>
          {Object.entries(gridItems).map((each) => (
            <InfoColumnItem
              key={each[0]}
              item={each}
              infoIcon={infoIcon}
              detailsIcon={detailsIcon}
              showEmojis={showEmojis}
              showHyphen={showHyphen}
              gridLabels={gridLabels}
              gridItems={gridItems}
              template={template}
              modulePosition={modulePosition}
            />
          ))}
        </div>
      ) : (
        <>
          {showTitle && (
            <h2>
              {generatePlaceholderString(
                useTranslate('operator_info_grid_title', '[operator_name] Information'),
                {},
                page?.relation
              )}
            </h2>
          )}
          {showGridItems()}

          {templateTwo && Object.values(gridItems).length > showInitial && (
            <button
              type="button"
              onClick={() => setShowMore(!showMore)}
              className={styles.singleColumnSeeMore || ''}
            >
              {showMore ? (
                <>
                  {' '}
                  {useTranslate('see_less_items', 'Show less items')}{' '}
                  <FaChevronUp title="Up-pointing Arrow Icon" />{' '}
                </>
              ) : (
                <>
                  {' '}
                  {useTranslate('see_more_items', 'Show more items')}{' '}
                  <FaChevronDown title="Down-pointing Arrow Icon" />{' '}
                </>
              )}
            </button>
          )}
        </>
      )}
    </div>
  );
};

InfoGrid.propTypes = {
  page: PropTypes.shape({
    template: PropTypes.string,
    relation: PropTypes.shape({}),
    market: PropTypes.string,
  }),
  showTwoColumns: PropTypes.bool,
  showTitle: PropTypes.bool,
  showHyphen: PropTypes.bool,
  infoIcon: PropTypes.element,
  detailsIcon: PropTypes.element,
  showEmojis: PropTypes.bool,
  showSeeMoreButton: PropTypes.bool,
  showInitial: PropTypes.number,
  templateThree: PropTypes.bool,
  modulePosition: PropTypes.number
};

export default InfoGrid;
